"use strict";
/*!
 *
 * app.js
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// import 'polyfill';
// global.Promise = require('es6-promise').Promise;
require("picturefill");
/*** node_modules **/
require("jquery.easing");
require("slick-carousel");
/*** ./modules **/
var hasher_1 = __importDefault(require("hasher"));
var linker_1 = __importDefault(require("linker"));
var slide_scroll_1 = __importDefault(require("slide-scroll"));
var tel_handler_1 = __importDefault(require("tel-handler"));
require("@fancyapps/fancybox");
require("fancy-defaults");
// import Page2Top from 'page2top';
var object_fit_images_1 = __importDefault(require("object-fit-images"));
var object_fit_videos_1 = __importDefault(require("object-fit-videos"));
var tab_1 = __importDefault(require("tab"));
var top_1 = __importDefault(require("top"));
var menu_1 = __importDefault(require("menu"));
var scroll_anim_1 = __importDefault(require("scroll-anim"));
require("gallery");
require("swipe-elem");
require("accordion");
var header_1 = __importDefault(require("header"));
(0, hasher_1.default)();
$(function () {
    new menu_1.default();
    // new Page2Top();
    new linker_1.default();
    (0, tel_handler_1.default)();
    (0, slide_scroll_1.default)({
        easing: 'easeOutExpo',
        speed: 700,
        not: '.sw-NotScroll, .sw-Modal, .tea-Modal, .sw-TabLink'
    });
    (0, header_1.default)();
    $('.sw-Modal').fancybox({
        hash: false,
        animationDuration: 500,
        transitionDuration: 500,
        beforeShow: function (instance, current) {
            $('.c-Gallery').addClass('-show-modal');
        },
        afterClose: function (instance, current) {
            $('.c-Gallery').removeClass('-show-modal');
        }
    });
    $('.tea-Modal').fancybox({
        baseClass: 'tea-FancyBox',
        infobar: false,
        hash: false
    });
    $('.c-Gallery').gallery();
    $('.sw-Swipe').swipeElem();
    $('.c-Acod').accordion();
    new tab_1.default();
    new scroll_anim_1.default();
    // new Teacher();
    (0, top_1.default)();
    (0, object_fit_images_1.default)('img.sw-ObjectFit', { watchMQ: true });
    (0, object_fit_videos_1.default)(document.querySelectorAll('video.sw-ObjectFit'));
});
$(window).on('load', function () {
    $('#Menu').addClass('-loaded');
});
